import {
	Box,
	Stack,
	styled,
	Tab,
	Tabs,
} from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";
import MyData from "./MyData";
import { MyReservations } from "./MyReservations";

const StyledTab = styled(Tab)(() => ({
	flex: 1,
	"&.MuiButtonBase-root": {
		fontWeight: 600,
		textTransform: "initial",
	},
}));

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index } = props;

	return (
		<Stack role="tabpanel" hidden={value !== index} width="100%" alignItems="center">
			{value === index && children}
		</Stack>
	);
}

const Profile = ({ setSuccess }) => {
	const { formatMessage } = useIntl();

	const [selectedTab, setSelectedTab] = React.useState(0);

	const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<Stack
			sx={{ width: { mobile: "90%", xs: "80%", sm: "90%", md: "85%" } }}
			alignItems="center"
		>
			<Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={selectedTab}
					onChange={handleChangeTab}
					sx={{ width: "100%" }}
					centered
				>
					<StyledTab
						label={formatMessage({
							id: "profile.myData",
							defaultMessage: "Mis datos",
						})}
					/>
					<StyledTab
						label={formatMessage({
							id: "profile.myReservations",
							defaultMessage: "Mis reservas",
						})}
					/>
				</Tabs>
			</Box>
			<TabPanel value={selectedTab} index={0}>
				<MyData setSuccess={setSuccess} />
			</TabPanel>
			<TabPanel value={selectedTab} index={1}>
				<MyReservations />
			</TabPanel>
		</Stack>
	);
};

export default Profile;
